module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "chara-thumb"
  }, [_c('router-link', {
    staticClass: "chara-thumb__link",
    attrs: {
      "to": {
        name: 'chara',
        params: {
          story: _vm.story,
          id: _vm.id
        }
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.thumb,
      "alt": ""
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cee16184"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/chara/chara-thumb.vue
// module id = 60
// module chunks = 0